<a class="toggleUi" (click)="toggleUi()">
  <span [ngClass]="!isCollapsed ? 'collapseIcon' : 'expandIcon'"></span>
  @if (!isCollapsed) {
    <span class="label">
      {{ 'asm.toggleUi.collapse' | cxTranslate }}
    </span>
  }
  @if (isCollapsed) {
    <span class="label">
      {{ 'asm.toggleUi.expand' | cxTranslate }}
    </span>
  }
</a>
